import Vue from 'vue'
import Router from 'vue-router'
import Top from '@/components/top'
import LayoutWorks from '@/components/layouts/works'
import WorksTop from '@/components/works/worksTop'
import Techbookfest05 from '@/components/works/techbookfest05'
import Slides from '@/components/works/slides'
import Kameneko from '@/components/kameneko'
import E404 from '@/components/error/e404'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'top',
      component: Top
    },
    {
      path: '/kameneko',
      name: 'Kameneko',
      component: Kameneko
    },
    {
      path: '/works',
      name: 'Works',
      component: LayoutWorks,
      children: [
        {
          path: '/',
          name: 'worksTop',
          component: WorksTop
        },
        {
          path: 'techbookfest05',
          name: 'TechBookFest05',
          component: Techbookfest05
        },
        {
          path: 'slides',
          name: 'Slides',
          component: Slides
        }
      ]
    },
    {
      path: '*',
      name: 'e404',
      component: E404,
      title: '404 Page Not Found'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js